<template>
    <div v-if="mode == 'heart'" class="w-like-heart" @click="blast">
        <span class="w-heart" ref="likeheart"></span>
        <span class="u-text">{{ txt || "喜欢" }}</span>
        <span class="u-count" v-if="showCount">{{ total }}</span>
    </div>
    <el-button v-else class="w-like" size="mini" type="primary" @click="doLike">
        <i v-if="!status" class="u-heart">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M256 482.164a14.97 14.97 0 01-9.88-3.713l-.655-.574c-21.813-19.085-42.302-36.544-62.115-53.429-53.171-45.309-99.088-84.437-131.005-122.397C16.633 259.578 0 219.954 0 177.351c0-39.138 13.267-75.746 37.355-103.08C62.609 45.616 97.642 29.836 136 29.836c53.948 0 88.103 32.22 107.255 59.25 4.97 7.014 9.196 14.047 12.745 20.665 3.549-6.618 7.776-13.651 12.745-20.665 19.152-27.029 53.307-59.25 107.255-59.25 38.358 0 73.391 15.781 98.644 44.435C498.733 101.605 512 138.213 512 177.351c0 42.603-16.633 82.228-52.345 124.7-31.917 37.96-77.834 77.088-131.002 122.395-19.816 16.887-40.305 34.346-62.118 53.431l-.655.574a14.964 14.964 0 01-9.88 3.713zM136 59.836c-29.621 0-56.66 12.171-76.138 34.271C40.605 115.957 30 145.521 30 177.351c0 77.007 68.745 135.588 172.804 224.261 17.083 14.557 34.662 29.537 53.196 45.648 18.535-16.112 36.113-31.091 53.193-45.646C413.255 312.939 482 254.358 482 177.351c0-31.83-10.605-61.394-29.863-83.245-19.477-22.099-46.516-34.27-76.137-34.27-41.129 0-67.716 25.338-82.776 46.594-13.509 19.065-20.558 38.282-22.962 45.66a15 15 0 01-28.524 0c-2.404-7.377-9.453-26.595-22.962-45.659-15.06-21.257-41.647-46.595-82.776-46.595z"/></svg>
        </i>
        <i v-else class="u-heart">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M256 481a14.93 14.93 0 01-9.873-3.706c-21.826-19.087-42.583-36.782-62.109-53.423C73.817 329.96 0 267.909 0 177.514 0 93.988 59.037 31 136 31c60.659 0 99.595 42.378 120 80.537C276.405 73.378 315.341 31 376 31c76.963 0 136 62.988 136 146.514 0 90.396-73.817 152.446-184.018 246.357-19.526 16.641-40.283 34.336-62.109 53.423A14.93 14.93 0 01256 481z" fill="#fd3018"/><path d="M265.873 477.294c21.826-19.087 42.583-36.782 62.109-53.423C438.183 329.96 512 267.909 512 177.514 512 93.988 452.963 31 376 31c-60.659 0-99.595 42.378-120 80.537V481c3.53 0 7.046-1.23 9.873-3.706z" fill="#e61e14"/></svg>
        </i>
        <span>喜欢</span>
    </el-button>
</template>

<script>
import { postStat } from "@jx3box/jx3box-common/js/stat";
import { getRewrite } from "@jx3box/jx3box-common/js/utils";
import _ from "lodash";
export default {
    name: "Like",
    props: [
        "mode",
        "txt",
        "showCount",
        "count",
        "postType",
        "postId",
    ],
    data: function () {
        return {
            pid:  this.postId || getRewrite("pid"),
            type: this.postType || location.pathname.split("/")[1],
            status: false,
            total: this.count || 0,
            clicks: 0,
        };
    },
    computed: {},
    watch: {
        count: function () {
            this.total = this.count || 0;
        },
    },
    methods: {
        addLike: function () {
            return (
                this.type && this.pid && postStat(this.type, this.pid, "likes")
            );
        },
        doLike: function () {
            this.status = !this.status;
            this.status && this.pid && this.addLike();
        },
        doLikes: _.throttle(function () {
            this.addLike();
        }, 2000),
        blast: function () {
            this.$refs.likeheart.classList.add("w-heart-animation");
            setTimeout(() => {
                this.$refs.likeheart.classList.remove("w-heart-animation");
            }, 800);

            this.total++;
            this.clicks++;
            this.doLikes();
        },
    },
    mounted: function () {},
};
</script>

<style lang="less">
@import "../../assets/css/like.less";
</style>
